document.addEventListener('DOMContentLoaded', function() {
  //――――――――――――――――――――――――――――――――――――――
  // 1. アンカーを見つけてラップする関数を定義
  //――――――――――――――――――――――――――――――――――――――
  function wrapFavoriteAnchors() {
    // 未処理の<a>だけを選択するためのセレクタ
    // 「親要素に .favoritelist-item-wrapper クラスをもつものはスキップ」
    const rawAnchors = document.querySelectorAll(
      '.storecrm_favoritelist_lefttd a:not(.favoritelist-product):not(.favoritelist-variant)'
    );

    rawAnchors.forEach(function(a) {
      // もしすでにラップ済み（親が .favoritelist-item-wrapper）ならスキップ
      if (a.parentElement.classList.contains('favoritelist-item-wrapper')) return;

      const text = a.textContent.trim();
      const parent = a.parentNode;

      // 新しいラッパー要素を作る（縦並び・flex）
      const wrapper = document.createElement('div');
      wrapper.classList.add('favoritelist-item-wrapper');
      wrapper.style.display = 'flex';
      wrapper.style.flexDirection = 'column';

      if (text.includes(' - ')) {
        const parts = text.split(' - ');

        // 商品名用クローン
        const cloneProduct = a.cloneNode(false);
        cloneProduct.textContent = parts[0];
        cloneProduct.classList.add('favoritelist-product');
        cloneProduct.style.display = 'block';

        // バリエーション名用クローン
        const cloneVariant = a.cloneNode(false);
        cloneVariant.textContent = parts[1];
        cloneVariant.classList.add('favoritelist-variant');
        cloneVariant.style.display = 'block';

        wrapper.appendChild(cloneProduct);
        wrapper.appendChild(cloneVariant);
      } else {
        // 「 - 」がないときは全体を商品名扱い（バリエーションクローンは作らない）
        const cloneProductOnly = a.cloneNode(false);
        cloneProductOnly.textContent = text;
        cloneProductOnly.classList.add('favoritelist-product');
        cloneProductOnly.style.display = 'block';
        wrapper.appendChild(cloneProductOnly);
      }

      // 元の <a> の位置に wrapper を挿入し、元の <a> は削除
      parent.insertBefore(wrapper, a);
      parent.removeChild(a);
    });
  }

  //――――――――――――――――――――――――――――――――――――――
  // 2. まず初回に実行しておく
  //――――――――――――――――――――――――――――――――――――――
  wrapFavoriteAnchors();

  //――――――――――――――――――――――――――――――――――――――
  // 3. MutationObserver で再描画（DOMノードの差し替え）を監視
  //――――――――――――――――――――――――――――――――――――――
  // 監視対象ノード：お気に入り一覧全体のコンテナ（必要に応じて子ノードまで観察）
  const targetNode = document.querySelector('.storecrm_favoritelist');
  if (!targetNode) return; // 念のため、存在しない場合は何もしない

  const observer = new MutationObserver(function(mutations) {
    // DOM変化が起きたら再度アンカーのラップ処理を試みる
    wrapFavoriteAnchors();
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
    // ※ class や属性の変化を監視したいなら attributes: true を追加
  });
});
